import React, { useState, useEffect } from 'react'
import { Navigate } from 'react-router-dom'
import './Error_Handling.css'
import Dialog from '../../node_modules/@mui/material/Dialog'
import DialogContent from '../../node_modules/@mui/material/DialogContent'
import DialogContentText from '../../node_modules/@mui/material/DialogContentText'
import DialogTitle from '../../node_modules/@mui/material/DialogTitle'
import DialogActions from '../../node_modules/@mui/material/DialogActions'
import Button from '../../node_modules/@mui/material/Button'
import Environment from './env_var'

const Error_Handling = (props) => {
	const [showDialog, setShowDialog] = useState(true)
	const [errorName, setErrorName] = useState('')
	const [redirect, setRedirect] = useState(false)
	const [redirectURL, setRedirectURL] = useState(null)
	const fetchDomain = Environment.environment.env === 'production' ? Environment.environment.productionURL
	: Environment.environment.stagingURL
	
	
	const handleErrorConfirm = () => {
		setShowDialog(false)
		if (props.redirectURL === "") {
			//check for special case no redirect url
			props.handleErrorAcknowledge()
		} else {
			//set redirect url
			if (props.redirectType === 'external') {
				setRedirectURL(window.location.href=`${fetchDomain}${props.redirectURL}`)
			} else {
				setRedirectURL(
					<Navigate 
					to={{
						pathname : props.redirectURL
					}}
					state={{
						isLoggedIn: false,
						requestingLogin: false,
						error: false,
						loginError: props.errorCode === 403 ? true:false
					}}
				/>)
				setRedirect(true)
			}
		}
	}
	
	useEffect(() => {
		
		switch(props.errorCode) {
			case 401:
				setErrorName('Login Attempt Failed')
				break
			case 402:
				setErrorName('Account Disabled')
				break
			case 403:
				setErrorName('Please Login')
				break
			case 405:
				setErrorName('User Session Not Recognized')
				break
			case 418:
				setErrorName('Updating')
				break
			case 444:
				setErrorName('Something Went Wrong')
				break
			default:
				setErrorName('Error')
				break
		}
	},[props.errorCode])
	
	return (
		<React.Fragment>
		{redirect === true ? redirectURL : null}
		<Dialog 
			open={showDialog}
		>
			<DialogTitle>{errorName}</DialogTitle>
			<DialogContent>
				<DialogContentText>{props.errorMessage}</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button 
					onClick={handleErrorConfirm} 
					variant='outlined' 
					color='primary' 
					size='large'>
				OK
				</Button>
			</DialogActions>
		</Dialog>
		</React.Fragment>
	)
}

export default Error_Handling
